import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const DayCare = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="day-care"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6 5a1 1 0 00-1 1v21.8a1 1 0 001 1h21.8a1 1 0 001-1V6a1 1 0 00-1-1H19.6zm10.964 11.015c1.001 0 1.92.502 2.46 1.345l1.302 2.03c.216.337.315.726.288 1.125-.028.399-.18.77-.44 1.075a1.837 1.837 0 01-1.408.648 1.84 1.84 0 01-.742-.157 3.636 3.636 0 00-2.895-.011l-.024.01c-.367.162-.767.2-1.157.11a1.838 1.838 0 01-.994-.6 1.838 1.838 0 01-.439-1.075 1.838 1.838 0 01.288-1.125l1.302-2.03a2.91 2.91 0 012.46-1.345zm-3.41 1.342c.387-.149.68-.46.828-.878.14-.398.128-.847-.033-1.264a1.834 1.834 0 00-.823-.96 1.419 1.419 0 00-1.203-.096c-.777.299-1.134 1.26-.795 2.142.27.702.903 1.146 1.541 1.146.163 0 .327-.03.485-.09zm4.287-3.598c0 1.107-.79 2.008-1.763 2.008-.971 0-1.762-.9-1.762-2.008s.79-2.009 1.762-2.009 1.763.901 1.763 2.009zm1.281 2.501c.15.05.303.073.454.073.71 0 1.4-.515 1.664-1.308a1.97 1.97 0 00-.028-1.36c-.178-.438-.508-.757-.928-.897-.421-.14-.876-.082-1.281.164a1.97 1.97 0 00-.836 1.071c-.32.963.109 1.975.955 2.257zm3.712-.234c.67.496.758 1.517.196 2.276-.358.483-.893.746-1.407.746-.295 0-.584-.087-.828-.267-.67-.496-.757-1.517-.195-2.277.562-.759 1.564-.973 2.234-.478zM33.2 32.2a1 1 0 00-1 1V55a1 1 0 001 1H55a1 1 0 001-1V33.2a1 1 0 00-1-1H33.2zm11.665 7.897c.439-.34.936-.511 1.479-.511 1.514 0 2.656 1.239 2.656 2.881 0 1.775-1.425 2.989-3.581 4.826-.367.313-.782.666-1.213 1.044a.313.313 0 01-.412 0c-.431-.377-.846-.731-1.212-1.043C40.424 45.456 39 44.242 39 42.467c0-1.642 1.142-2.881 2.656-2.881.543 0 1.04.172 1.479.511.42.325.7.74.865 1.04a3.37 3.37 0 01.865-1.04zM6 32.2a1 1 0 00-1 1V55a1 1 0 001 1h21.8a1 1 0 001-1V33.2a1 1 0 00-1-1H6zm12.572 9.637L17 37l-1.572 4.837h-5.085l4.114 2.99-1.572 4.836L17 46.673l4.114 2.99-1.571-4.837 4.114-2.99h-5.085z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

DayCare.defaultProps = {
  className: null,
};

DayCare.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default DayCare;
